import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getPagePaperStyles } from "../../../constants/pageStyles";
import { typography } from "../../../constants/designTokens";
import { appColors } from "../../../constants/theme";

/** Wizard adım başlıkları — tüm step'lerde aynı boyut */
export const stepTitleSx = {
  fontWeight: 600,
  mb: 2,
  color: appColors.gray900,
  textAlign: "left",
  fontSize: "1.125rem",
  lineHeight: 1.35,
};

export const StyledContainer = styled("div")(({ theme }) => ({
  width: "100%",
  minHeight: "100vh",
  background: theme.palette.success.contrastText,
  [theme.breakpoints.up("md")]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const StyledInnerContainer = styled("div")(({ theme, background }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  flexDirection: "column",
  paddingBottom: "4rem",
  background: background ? background : theme.palette.primary.contrastText,
  [theme.breakpoints.up("md")]: {
    minHeight: "100vh",
  },
}));

export const StyledPaper = styled(Paper)(({ theme }) =>
  getPagePaperStyles(theme, {
    minWidth: "320px",
    maxWidth: "480px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  })
);

export const StyledStepContainer = styled("div")(() => ({
  width: "100%",
}));

export const StyledTitle = styled("h1")(({ theme }) => ({
  fontSize: `${typography.fontSize.xl}px`,
  padding: `${theme.spacing(3)} 0`,
  color: theme.palette.text.primary,
  fontWeight: typography.fontWeight.semibold,
}));
